// import * as Config from '../../../config';
import React, { useState, useCallback, useEffect, useRef } from 'react';
// import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import { debounce } from "throttle-debounce";
// import { MenuItem } from "react-contextmenu";
import './FilterInput.css';
import dayjs from 'dayjs';
import { Root, Trigger, Content, Item, Portal } from "@radix-ui/react-context-menu";

// import { showMenu } from 'react-contextmenu/modules/actions';
// import { setContextMenu } from "../../../actions/index";
import { getContextMenuPortalContainer, rightClickContextMenu } from "../../../utils/zoomMenu";

function FilterDate({ flexShrink, type, placeholder, value, onValid }) {
  const elInput = useRef();
  // const dispatch = useDispatch();
  const [val, setVal] = useState(value);
  const [focus, setFocus] = useState(false);
  // const forceFocus = () => {
  //   if (Config.TOUCH_ENABLED) {
  //     elInput.current.focus()
  //   }
  // }

  useEffect(() => { setVal(value) }, [value])

  const debouncedApply = useCallback(debounce(1000, (v) => {
    onValid(type, v)
  }), [])
  const search = (value) => {
    setVal(value);
    debouncedApply(value);
  }
  const onChange = (e) => { search(e.target.value) }
  const onClear = () => { search(``) }

  const list = [
    {label: 'Today', value: `${dayjs().format(`YYYY-MM-DD`)}:${dayjs().format(`YYYY-MM-DD`)}` },
    {label: 'Yesterday', value: `${dayjs().subtract(1, 'day').format(`YYYY-MM-DD`)}:${dayjs().subtract(1, 'day').format(`YYYY-MM-DD`)}`},
    {label: 'Last 7 days', value: `${dayjs().subtract(7, 'day').format(`YYYY-MM-DD`)}:${dayjs().format(`YYYY-MM-DD`)}`},
    {label: 'Last 30 days', value: `${dayjs().subtract(30, 'day').format(`YYYY-MM-DD`)}:${dayjs().format(`YYYY-MM-DD`)}`},
  ]
  const selectDate = (date) => () => { search(date) };
  const showContextMenu = (e) => {
    // V1
    // const content = list.map((x,i) => <MenuItem 
    //   key={`date-filter-{i}`}
    //   onClick={selectDate(x.value)} 
    //   data={{ action: x.label }}>
    //   <div className={'flexRow block-contextmenu-item'}>
    //     {x.label}
    //   </div>
    // </MenuItem>);
    // dispatch(setContextMenu(content, {className: 'dynamic-menu-row-menu'}));
    // const p = elInput.current.getBoundingClientRect();
    // showMenu({
    //   position: {x: p.left + 90, y: p.top + p.height + 15},
    //   target: {},
    //   id: `DynamicMenu`
    // })

    // V2
    rightClickContextMenu(e);
  }

  const prepareFocus = (e) => {
    setFocus(true);
    showContextMenu(e);
  }
  const prepareBlur = () => {
    setFocus(false);
  }
  const prepareClick = (e) => {
    if (value.length === 0) {
      prepareFocus(e);
      // showContextMenu(e)
    }
  }
  const onCloseAutoFocus = (e) => {
    prepareBlur();
     e.preventDefault();
  }

  //  onFocus={prepareFocus} onBlur={prepareBlur}
  return (
    <div className={`flexRow align filter-container ${(value.length > 0) && `extend`} ${focus && `focus`} ${flexShrink > 1 && `small`} allow-menu`}
      style={{ flexShrink }}
      tabIndex={0}
    >
      <Root modal={false}>
        <Trigger>
          <input ref={elInput} type="text" onChange={onChange} value={val}
            placeholder={placeholder}
            onClick={/*forceFocus*/prepareClick} className={`filter-input-v2`}
          />
        </Trigger>
        <Portal container={getContextMenuPortalContainer()}>
          <Content
            className={'dynamic-menu-v2'}
            onCloseAutoFocus={onCloseAutoFocus}
            style={(window.window_zoom || 1) !== 1
              ? { transform: `scale(${window.window_zoom})`, transformOrigin: 'top left' }
              : undefined}
          >
            { list.map((x,i) => (
              <Item key={`date-filter-${i}`} onSelect={selectDate(x.value)}>
                <div className={'flexRow block-contextmenu-item-v2'}>
                  {x.label}
                </div>
              </Item>
            )) }
          </Content>
        </Portal>
      </Root>
      { (value.length > 0) && (
        <div className="type-small brand-primary button-clear" onClick={onClear}>
          <span>Clear</span>
        </div>
      )}
    </div>
  )
}

FilterDate.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onValid: PropTypes.func.isRequired
}

export default FilterDate;
